// Texte für den vierstufigen Analyse-Assistenten (de = Standard, en, tr).
import { useLang } from "./i18n";
export const wizardDe = {
  pageTitle: "Kostenlose Analyse",
  restart: "Von vorn beginnen",
  back: "Zurück",
  next: "Weiter",
  optional: "optional",
  steps: ["Unternehmen", "Leistung", "Kontaktdaten"],
  business: {
    title: "Um welches Unternehmen geht es?",
    lead: "Diese Angaben brauchen wir, um Ihr Unternehmen in Karten, Verzeichnissen und KI-Antworten zu finden.",
    name: "Unternehmensname",
    namePlaceholder: "z. B. Friseursalon Muster",
    city: "Ort",
    cityPlaceholder: "z. B. Wuppertal",
    website: "Website",
    websitePlaceholder: "https://…",
    errors: {
      name: "Bitte geben Sie den Unternehmensnamen an.",
      city: "Bitte geben Sie den Ort an."
    }
  },
  service: {
    title: "Mit welcher Leistung möchten Sie gefunden werden?",
    lead: "Mit welchem Suchbegriff sollten Kundinnen und Kunden Sie finden? Tippen Sie ihn ein oder wählen Sie einen Vorschlag.",
    label: "Suchbegriff eingeben",
    placeholder: "z. B. Friseur",
    select: "Übernehmen",
    suggestionsLabel: "Vorschläge",
    suggestionsNote: "(nur ein Begriff wählbar)",
    suggestions: ["Friseur", "Restaurant", "Zahnarzt", "Handwerker", "Rechtsanwalt"],
    selectedLabel: "Gewählter Suchbegriff",
    clear: "Auswahl entfernen",
    info: "Das ist der Begriff, den Ihre Kundschaft bei Google oder im KI-Assistenten eingibt. Die Wahl beeinflusst die Genauigkeit der Auswertung.",
    errors: {
      term: "Bitte wählen oder geben Sie einen Suchbegriff ein."
    }
  },
  contact: {
    title: "Kontaktdaten",
    lead: "Damit wir Ihnen den Bericht zusenden und Rückfragen klären können.",
    name: "Vor- und Nachname",
    namePlaceholder: "z. B. Ismail Keskin",
    email: "E-Mail-Adresse",
    emailPlaceholder: "name@ihrunternehmen.de",
    phone: "Telefon",
    phonePlaceholder: "+49 …",
    consent: "Ich bin damit einverstanden, dass meine Angaben zur Erstellung des Berichts verarbeitet werden.",
    consentLink: "Datenschutzerklärung",
    errors: {
      name: "Bitte geben Sie Ihren Namen an.",
      email: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
      consent: "Bitte bestätigen Sie die Einwilligung."
    }
  },
  summary: {
    title: "Bereit für die Analyse",
    lead: "Alle Angaben liegen vor. Die Analyse läuft in Echtzeit — Sie erhalten den Bericht direkt im Anschluss auf dieser Seite.",
    heading: "Zusammenfassung",
    business: "Unternehmen",
    city: "Ort",
    term: "Suchbegriff",
    email: "E-Mail",
    start: "Analyse starten",
    editStep: "Ändern"
  },
  running: {
    title: "Analyse läuft",
    note: "Das dauert nur einen Moment — bitte lassen Sie das Fenster offen.",
    stages: ["Digitale Spur wird erfasst …", "Karten- und Suchsichtbarkeit wird geprüft …", "KI-Tauglichkeit wird bewertet …", "Rechts- und Bildrechte-Check läuft …", "Bericht wird zusammengestellt …"],
    stageLabel: "Schritt {current} von {total}",
    processing: "In Arbeit …"
  },
  done: {
    title: "Analyse abgeschlossen",
    body: "Ihr kostenloser Kurzbericht ist fertig.",
    view: "Bericht ansehen",
    pdf: "PDF herunterladen",
    copy: "Link kopieren",
    copied: "Link kopiert",
    reusedNotice: "Wir haben Ihre Analyse vom {date} gefunden und zeigen sie Ihnen. Neue Analysen sind alle 30 Tage möglich.",
    pendingNote: "Der ausführliche Bericht mit allen Details und dem 3-Monats-Plan ist kostenpflichtig — die Option dazu finden Sie im Kurzbericht."
  }
};
export const wizardEn = {
  pageTitle: "Free analysis",
  restart: "Start over",
  back: "Back",
  next: "Continue",
  optional: "optional",
  steps: ["Business", "Service", "Contact details"],
  business: {
    title: "Which business is this about?",
    lead: "We need these details to find your business in maps, directories and AI answers.",
    name: "Business name",
    namePlaceholder: "e.g. Muster Hair Studio",
    city: "City",
    cityPlaceholder: "e.g. Wuppertal",
    website: "Website",
    websitePlaceholder: "https://…",
    errors: {
      name: "Please enter the business name.",
      city: "Please enter the city."
    }
  },
  service: {
    title: "Which service should you be found for?",
    lead: "Which search term should customers use to find you? Type it in or pick a suggestion.",
    label: "Enter a search term",
    placeholder: "e.g. hairdresser",
    select: "Use term",
    suggestionsLabel: "Suggestions",
    suggestionsNote: "(one term only)",
    suggestions: ["Hairdresser", "Restaurant", "Dentist", "Tradesperson", "Lawyer"],
    selectedLabel: "Selected search term",
    clear: "Remove selection",
    info: "This is the term your customers type into Google or an AI assistant. It affects how precise the analysis is.",
    errors: {
      term: "Please choose or enter a search term."
    }
  },
  contact: {
    title: "Contact details",
    lead: "So we can send you the report and follow up on questions.",
    name: "First and last name",
    namePlaceholder: "e.g. Ismail Keskin",
    email: "Email address",
    emailPlaceholder: "name@yourbusiness.com",
    phone: "Phone",
    phonePlaceholder: "+49 …",
    consent: "I agree that my details may be processed in order to produce the report.",
    consentLink: "privacy policy",
    errors: {
      name: "Please enter your name.",
      email: "Please enter a valid email address.",
      consent: "Please confirm your consent."
    }
  },
  summary: {
    title: "Ready to analyse",
    lead: "Everything is in place. The analysis runs in real time — you'll get the report right here afterwards.",
    heading: "Summary",
    business: "Business",
    city: "City",
    term: "Search term",
    email: "Email",
    start: "Start analysis",
    editStep: "Change"
  },
  running: {
    title: "Analysis running",
    note: "This only takes a moment — please keep this window open.",
    stages: ["Capturing your digital trail …", "Checking map and search visibility …", "Assessing AI readiness …", "Running legal and image-rights checks …", "Compiling the report …"],
    stageLabel: "Step {current} of {total}",
    processing: "Working …"
  },
  done: {
    title: "Analysis complete",
    body: "Your free summary report is ready.",
    view: "View report",
    pdf: "Download PDF",
    copy: "Copy link",
    copied: "Link copied",
    reusedNotice: "We found your analysis from {date} and are showing it to you. New analyses are possible every 30 days.",
    pendingNote: "The detailed report with every finding and the 3-month plan is a paid upgrade — you'll find that option inside the summary report."
  }
};
export const wizardTr = {
  pageTitle: "Ücretsiz analiz",
  restart: "Baştan başla",
  back: "Geri",
  next: "Devam et",
  optional: "opsiyonel",
  steps: ["İşletme", "Hizmet", "İletişim bilgileri"],
  business: {
    title: "Hangi işletme için analiz yapılacak?",
    lead: "İşletmenizi haritalarda, rehberlerde ve yapay zeka yanıtlarında bulabilmemiz için bu bilgiler gerekli.",
    name: "İşletme adı",
    namePlaceholder: "örn. Kuaför Muster",
    city: "Şehir",
    cityPlaceholder: "örn. Wuppertal",
    website: "Web sitesi",
    websitePlaceholder: "https://…",
    errors: {
      name: "Lütfen işletme adını girin.",
      city: "Lütfen şehri girin."
    }
  },
  service: {
    title: "Hangi hizmette öne çıkmak istiyorsunuz?",
    lead: "Müşterileriniz sizi hangi arama terimiyle bulmalı? Terimi yazın ya da hazır önerilerden seçin.",
    label: "Aramak istediğiniz terimi yazın",
    placeholder: "örn. kuaför",
    select: "Seç",
    suggestionsLabel: "Hazır öneriler",
    suggestionsNote: "(sadece 1 adet seçebilirsiniz)",
    suggestions: ["Kuaför", "Restoran", "Diş hekimi", "Tesisatçı", "Avukat"],
    selectedLabel: "Seçilen arama terimi",
    clear: "Seçimi kaldır",
    info: "Bu terim, müşterilerinizin Google'da veya yapay zeka asistanında kullandığı kelimelerdir. Doğru terim, analizin doğruluğu için önemlidir.",
    errors: {
      term: "Lütfen bir arama terimi seçin veya yazın."
    }
  },
  contact: {
    title: "İletişim bilgileri",
    lead: "Raporu size gönderebilmemiz ve sorularınızı yanıtlayabilmemiz için.",
    name: "Ad Soyad",
    namePlaceholder: "örn. İsmail Keskin",
    email: "E-posta adresi",
    emailPlaceholder: "ad@isletmeniz.com",
    phone: "Telefon",
    phonePlaceholder: "+49 …",
    consent: "Bilgilerimin rapor hazırlanması amacıyla işlenmesini kabul ediyorum.",
    consentLink: "gizlilik politikası",
    errors: {
      name: "Lütfen adınızı girin.",
      email: "Lütfen geçerli bir e-posta adresi girin.",
      consent: "Lütfen onayı işaretleyin."
    }
  },
  summary: {
    title: "Analiz başlatmaya hazır",
    lead: "Tüm bilgiler hazır. Analiz gerçek zamanlı çalışır — raporu tamamlandığında doğrudan burada göreceksiniz.",
    heading: "Özet",
    business: "İşletme",
    city: "Şehir",
    term: "Arama terimi",
    email: "E-posta",
    start: "Analizi başlat",
    editStep: "Değiştir"
  },
  running: {
    title: "Analiz sürüyor",
    note: "Sadece kısa bir süre alır — lütfen bu pencereyi açık tutun.",
    stages: ["Dijital iz kaydediliyor …", "Harita ve arama görünürlüğü kontrol ediliyor …", "Yapay zeka uyumluluğu değerlendiriliyor …", "Yasal ve görsel telif kontrolü yapılıyor …", "Rapor derleniyor …"],
    stageLabel: "{current} / {total} adım",
    processing: "İşleniyor …"
  },
  done: {
    title: "Analiz tamamlandı",
    body: "Ücretsiz özet raporunuz hazır.",
    view: "Raporu görüntüle",
    pdf: "PDF indir",
    copy: "Link kopyala",
    copied: "Link kopyalandı",
    reusedNotice: "{date} tarihli analizinizi bulduk ve size gösteriyoruz. Yeni analizler 30 günde bir yapılabilir.",
    pendingNote: "Tüm bulguları ve 3 aylık planı içeren ayrıntılı rapor ücretlidir — bu seçeneği özet raporun içinde bulabilirsiniz."
  }
};
const dict = {
  de: wizardDe,
  en: wizardEn,
  tr: wizardTr
};
export function useWizardT() {
  const {
    lang
  } = useLang();
  return dict[lang] ?? wizardDe;
}